window.fbs_click = function (link, width, height) {
  //Allow for borders.
  const leftPosition = (window.screen.width / 2) - ((width / 2) + 10);
  //Allow for title and status bars.
  const topPosition = (window.screen.height / 2) - ((height / 2) + 50);
  let windowFeatures = "status=no,height=" + height + ",width=" + width + ",resizable=yes,left=" + leftPosition + ",top=" + topPosition + ",screenX=" + leftPosition + ",screenY=" + topPosition + ",toolbar=no,menubar=no,scrollbars=no,location=no,directories=no";
  const u = new URL(link).searchParams.get('u');
  const t = document.title;
  window.open('http://www.facebook.com/sharer.php?u=' + encodeURIComponent(u) + '&t=' + encodeURIComponent(t), 'sharer', windowFeatures);

  return false;
}

window.pinterestShareHandler = function () {
  if ('PinUtils' in window) {
    PinUtils.pinAny();
  }
  return false;
}
